<template v-if="modelValue">
  <button
    v-if="showBackdrop"
    type="button"
    class="public-side-panel__backdrop"
    :style="panelStyle"
    :aria-label="resolvedCloseLabel"
    @click="handleBackdropClick"
  ></button>

  <aside
    :id="id"
    ref="panel"
    class="public-side-panel"
    :style="panelStyle"
    tabindex="-1"
    :aria-labelledby="titleId"
    @keydown.esc="close"
  >
    <div class="public-side-panel__header">
      <div class="public-side-panel__heading">
        <slot name="header">
          <div class="public-side-panel__title-row">
            <div>
              <span v-if="eyebrow">{{ eyebrow }}</span>
              <h5 :id="titleId">{{ title }}</h5>
            </div>
            <slot name="title-actions" />
          </div>
        </slot>
      </div>

      <button
        type="button"
        class="public-side-panel__close"
        :aria-label="resolvedCloseLabel"
        @click="close"
      >
        <i class="bi bi-x-lg"></i>
      </button>
    </div>

    <div class="public-side-panel__body">
      <slot />
    </div>

    <div v-if="$slots.footer" class="public-side-panel__footer">
      <slot name="footer" />
    </div>
  </aside>
</template>
